import { NodeEdge } from "@hex-insights/app-modules";
import { Grid, Heading, If, Modal, ModalProps } from "@hex-insights/core";
import {
	Newsletter,
	NewsletterFilterInput,
	NewsletterOrderField,
	OrderDirection,
	useNewsletterDisplayListQuery,
} from "../../../../Utilities";
import { NewsletterCard, NewsletterCardProps } from "../Card";

export type ControlledNewslettersListModalProps = Omit<NewslettersListModalProps, "isLoading" | "newsletterEdges"> & {
	filters?: NewsletterFilterInput;
};

export function ControlledNewslettersListModal({ filters, ...props }: ControlledNewslettersListModalProps) {
	const { loading, data } = useNewsletterDisplayListQuery({
		variables: {
			filters,
			order: { field: NewsletterOrderField.ReleaseAt, direction: OrderDirection.Desc },
			pagination: { first: 20 },
		},
	});

	return <NewslettersListModal isLoading={loading} newsletterEdges={data?.newsletterConnection.edges} {...props} />;
}

const responsiveTracks = {
	0: 1,
	600: 2,
	1000: 3,
};

export type NewslettersListModalProps = {
	isLoading?: boolean;
	newsletterEdges: NodeEdge<NewsletterCardProps["newsletter"]>[] | null | undefined;
	viewMap?: Record<Newsletter["id"], boolean>;
	detailModalVariant?: NewsletterCardProps["modalVariant"];
	footerContent?: React.ReactNode;
} & Pick<ModalProps, "ifRef" | "onClose" | "className" | "style">;

export function NewslettersListModal({
	newsletterEdges,
	viewMap,
	detailModalVariant,
	footerContent,
	ifRef,
	onClose,
	className,
	style,
}: NewslettersListModalProps) {
	return (
		<Modal ifRef={ifRef} size="large" onClose={onClose} className={className} style={style}>
			<Modal.Header>
				<Heading.H2 noMargin>Newsletters</Heading.H2>
			</Modal.Header>
			<Modal.Body>
				<Grid responsiveTracks={responsiveTracks} gap="1rem">
					{newsletterEdges?.map(({ node }) => (
						<NewsletterCard
							key={node.id}
							newsletter={node}
							isNew={!!viewMap && !viewMap[node.id]}
							variant="flat"
							withModalBackButton
							modalVariant={detailModalVariant}
						/>
					))}
				</Grid>
			</Modal.Body>
			<If condition={!!footerContent}>
				<Modal.Footer>{footerContent}</Modal.Footer>
			</If>
		</Modal>
	);
}
